export interface StockQty {
  sealedBoxes: number;
  loosePcs: number;
  qtyTotal: number;
}

/**
 * §5: «Остаток выводится как «К кор. + Р шт (всего Н)»».
 * §6.1: «При отрицательном остатке показываются только штуки.»
 */
export function formatStock(stock: StockQty): string {
  if (stock.qtyTotal < 0) return `${stock.qtyTotal} шт`;
  const parts: string[] = [];
  if (stock.sealedBoxes !== 0) parts.push(`${stock.sealedBoxes} кор.`);
  if (stock.loosePcs !== 0 || stock.sealedBoxes === 0) parts.push(`${stock.loosePcs} шт`);
  return `${parts.join(' + ')} (всего ${stock.qtyTotal})`;
}
